import clientLoader from './client-loader';

export default {
  clientLoader,
};
